import { type PropsWithChildren, createContext, useContext, useState } from 'react'

import { useEntitiesContext } from 'entities/EntitiesExport'
import { NotificationsStore } from 'pages/settings/pages/notifications/store/notificationsStore'

const NotificationsContext = createContext<NotificationsStore | null>(null)

export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with NotificationsProvider')

  return context
}

export const NotificationsProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new NotificationsStore(entities))

  return <NotificationsContext.Provider value={store}>{children}</NotificationsContext.Provider>
}
